import { CountdownPg } from './styled'

import lesaLogo from '../../assets/lesaLogo.png'
import asbLogo from '../../assets/asbLogo.png'
import bannerDesktop from '../../assets/bannerDesktop.png'
import bannerMobile from '../../assets/bannerMobile.png'
import appConfig from '../../config'
import { useEffect, useState } from 'react'

const Countdown = () => {
  const calculateTimeLeft = () => {
    const { year, month, day, hour, minute } = appConfig.EVENT_START_TIME
    const difference =
      +new Date(year, month - 1, day, hour, minute, 0, 0) - +new Date()
    let timeLeft = {}

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
    }

    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)
  })

  const timerComponents = []

  Object.keys(timeLeft).forEach((interval) => {
    if (isNaN(timeLeft[interval])) {
      return
    }

    timerComponents.push(
      <div className="col-6 col-sm-3 card" key={interval}>
        <div className="unit">{interval}</div>
        <div className="number">{timeLeft[interval]}</div>
      </div>
    )
  })

  const refreshPage = () => {
    window.location.reload()
  }

  return (
    <CountdownPg>
      <header>
        <img src={lesaLogo} alt="lesaLogo" className="logos p-4" width={280} />
        <div className="row countdown gap-4">
          {timerComponents.length ? (
            timerComponents
          ) : (
            <span className="timeup">
              Time's up!
              <button className="btn" onClick={refreshPage}>
                Enter Event
              </button>
            </span>
          )}
        </div>
        <img src={asbLogo} alt="asbLogo" className="logos" width={250} />
      </header>
      <footer>
        <picture>
          <source srcSet={bannerMobile} media="(max-width: 768px)" />
          <source srcSet={bannerDesktop} />
          <img src={bannerDesktop} alt="Background" />
        </picture>
      </footer>
    </CountdownPg>
  )
}

export default Countdown
